export default __webpack_public_path__ + "static/media/1015.6a514986.png";